import request from "../utils/request";


export const getProducts = '/product/';

export const getProductsQty = '/product/qty'

export function getAllProducts(){
    return request.get('/product/dict');
}
export const getAllProductsUrl = '/product/dict';

export function updateCode(id:any,code:any){
    return request.put('/product/code', {id,code});
}

export function modifyProduct(values:any){
    return request.request({
        url: '/product/',
        method: values.id? 'put': 'post',
        data: values
    });
}

export function deleteProduct(productId:number){
    return request.delete('/product/', {params: {id:productId}})
}

export function getProduct(id:number){
    return request.get('/product/getProduct',{params:{id}})
}

export function updateStatus(id:number, status:boolean){
    return request.post('/product/updateStatus', {id, status});
}

export function updateImage(id:number, image:string){
    return request.post('/product/updateImage', {id,image});
}

export function importGiveaways(file:File){
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/product/importGiveaways', formData)
}
export function updateQualityReports(id:number, qualityReports:Array<any>){
    return request.post('/product/updateQualityReports', {id, qualityReports});
}

export function synYunyigou(ids:Array<any>){
    return request.put('/product/setSync', ids);

}

export const exportProductQtyUrl = '/product/product/qtyExport';
